<template>
  <SAutocomplete v-bind="autocomplete.props" v-on="autocomplete.on">
    <template v-for="(_index, name) in $slots" #[name]="data">
      <slot :name="name" v-bind="data" />
    </template>
  </SAutocomplete>
</template>

<script setup lang="ts">
import type { UseComboboxPresetEmit } from "@/lib/components/logic/molecules/useComboboxPreset";

import * as useComboboxPreset from "@/lib/components/logic/molecules/useComboboxPreset";
import SAutocomplete from "@/lib/components/molecules/autocomplete/SAutocomplete.vue";

const props = defineProps(useComboboxPreset.props);
const emit = defineEmits<UseComboboxPresetEmit>();

const { autocomplete } = useComboboxPreset.use(props, emit);
</script>
